import { createReleaseNoteByodHttpRepository } from '@src/main/modules/parameters/infrastructure/repository/ReleaseNoteByodHttpRepository';
import { useAuth } from '@src/main/shared/context/AuthContext';
import { useQuery } from '@tanstack/react-query';

export const useReleaseNotesByod = () => {
  const { user } = useAuth();

  return useQuery({
    queryKey: ['release-notes-byod'],
    queryFn: async () => {
      if (!user?.token) throw new Error('User not authenticated');
      const tokenProvider = { getToken: async () => user.token };
      const repository = createReleaseNoteByodHttpRepository(tokenProvider);
      return await repository.findAll();
    },
    enabled: !!user?.token,
    staleTime: 1000 * 60 * 5,
  });
};
